document.addEventListener('DOMContentLoaded', function() {

  const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
  let activeMenuItem = null;

  menuItems.forEach((item, index) => {
    const detailsElement = item.querySelector('details');
    if (!detailsElement) {
      return;
    }

    item.addEventListener('mouseenter', () => {
      if (activeMenuItem && activeMenuItem !== item) {
        const previousDetailsElement = activeMenuItem.querySelector('details');
        if (previousDetailsElement) previousDetailsElement.removeAttribute('open');
      }
      detailsElement.setAttribute('open', true);
      activeMenuItem = item;
    });

    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        // Re-check hover state *inside* timeout
        // A better check might involve the detailsElement content as well,
        // but this mimics the image script logic.
        if (!item.matches(':hover')) {
           const currentDetails = item.querySelector('details');
           if (currentDetails && !currentDetails.querySelector('.mega-menu__content:hover')) {
               detailsElement.removeAttribute('open');
               if (activeMenuItem === item) activeMenuItem = null;
           }
        }
      }, 300); // Adjust delay as needed (e.g., 300ms)
    });

    // Add mouseenter listener to the dropdown content itself to prevent closing
    const menuContent = detailsElement.querySelector('.mega-menu__content');
    if (menuContent) {
        menuContent.addEventListener('mouseenter', () => {
            // When entering the content, ensure the parent item is marked as active
             if (activeMenuItem !== item) {
                 if (activeMenuItem) {
                     const previousDetailsElement = activeMenuItem.querySelector('details');
                     if (previousDetailsElement) previousDetailsElement.removeAttribute('open');
                 }
                 detailsElement.setAttribute('open', true);
                 activeMenuItem = item;
             }
        });

        menuContent.addEventListener('mouseleave', (event) => {
             // Check if the mouse moved back to the parent li or outside completely
             if (!item.contains(event.relatedTarget)) {
                  detailsElement.removeAttribute('open');
                  if (activeMenuItem === item) activeMenuItem = null;
             }
        });
    }

  });

  // Close menu if clicking outside
  document.addEventListener('click', (event) => {
      if (activeMenuItem && !activeMenuItem.contains(event.target)) {
           const detailsToClose = activeMenuItem.querySelector('details');
           if (detailsToClose) detailsToClose.removeAttribute('open');
           activeMenuItem = null;
      }
  });

});